import { AwsIconUrl } from "@p0security/shared/integrations/constants";
import { AwsComponents } from "@p0security/shared/integrations/resources/aws/components";
import { Typography } from "antd";
import { useCallback } from "react";
import { Link } from "react-router-dom";

import { Install, InstallProps } from "../Install/Install";
import { awsInstaller } from "./install";

const AwsPreamble = (
  <>
    <Typography.Paragraph>
      Connect AWS to enable IAM management and resource-level access control for
      your AWS accounts.
    </Typography.Paragraph>
    <Typography.Text strong>
      Recommended components by use case:
    </Typography.Text>
    <ul className="preamble-list">
      <li>
        <strong>Just-in-time access:</strong>{" "}
        <Link to="./iam-write">IAM Management</Link>, and optionally{" "}
        <Link to="./inventory">Resource Inventory</Link> and{" "}
        <Link to="./access-logs">Access Logging</Link>
      </li>
      <li>
        <strong>Inventory and Posture:</strong>{" "}
        <Link to="./iam-assessment">IAM Assessment</Link> and{" "}
        <Link to="./inventory">Resource Inventory</Link>
      </li>
      <li>
        <strong>Custom notifiers:</strong>{" "}
        <Link to="./function-caller">Function Invocation</Link>
      </li>
    </ul>
  </>
);

export const Aws = (
  props: Pick<InstallProps<typeof AwsComponents>, "cardOverride" | "onInstall">
) => {
  const itemKind = useCallback(
    (componentKey: string) =>
      componentKey === "function-caller"
        ? "lambda"
        : componentKey === "rds-security-perimeter"
          ? "Security Perimeter"
          : "account",
    []
  );
  const identifier = useCallback(
    (componentKey: string) =>
      componentKey === "function-caller" ? "ARN" : "identifier",
    []
  );
  return (
    <Install<typeof AwsComponents>
      components={AwsComponents}
      installer={awsInstaller}
      integration="aws"
      itemKind={itemKind}
      identifier={identifier}
      logo={AwsIconUrl}
      preamble={AwsPreamble}
      title={"Amazon Web Services"}
      {...props}
    />
  );
};
